import types from 'constants/actionTypes';
import { combineReducers } from 'redux';
import mergeByIds from '../../utils/mergeByIds';
import { omit, get, mergeWith } from 'lodash';

const updatePriority = (updatedState, newPriority, templateId) => {
  const prevPriority = Object.keys(
    updatedState[templateId].prioritiesToQuantitiesMap,
  )[0];

  const currentQuantity = Object.values(
    updatedState[templateId].prioritiesToQuantitiesMap,
  ).filter(val => val > 0)[0];

  if (parseInt(prevPriority, 0) !== newPriority) {
    updatedState[templateId].prioritiesToQuantitiesMap[
      newPriority
    ] = currentQuantity;
    delete updatedState[templateId].prioritiesToQuantitiesMap[prevPriority];
  }
};

const initialState = {
  byId: {},
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_MODEL_TEMPLATES_WORKING_STATE_REQUEST_SUCCESS:
    case types.ADD_TEMPLATES_TO_CART_REQUEST_SUCCESS:
      return mergeByIds({
        byIdCurrent: state,
        byIdToMerge: payload.entities.templatesStates,
      });
    case types.UPDATE_IN_REVIEW_TEMPLATE_PRIORITY: {
      const { priority, templateId } = payload;
      const updatedState = { ...state };
      updatePriority(updatedState, priority, templateId);
      return { ...updatedState };
    }
    case types.UPDATE_PRIORITY_QUANTITY: {
      const { templateId, priority, quantity } = payload;
      const updatedState = { ...state };
      const prioritiesQuantities =
        updatedState[templateId].prioritiesToQuantitiesMap;
      const defaultPriority = 3;
      if (priority === 'n/a') {
        prioritiesQuantities[defaultPriority] = quantity;
      } else if (quantity === 0) {
        delete prioritiesQuantities[priority];
      } else {
        prioritiesQuantities[priority] = quantity;
      }
      return { ...updatedState };
    }
    case types.REMOVE_TEMPLATE_FROM_WORKING_STATE: {
      const { templateId } = payload;
      const updatedState = { ...state };
      delete updatedState[templateId];

      return updatedState;
    }
    case types.ADD_TEMPLATE_TO_WORKING_STATE: {
      let updatedState = { ...state };
      let newTemplate = {
        id: payload.templateId,
        status: 'inReview',
        prioritiesToQuantitiesMap: {},
      };
      updatedState[payload.templateId] = newTemplate;
      return updatedState;
    }
    case types.SWAP_TEMPLATES: {
      const { oldTemplateId, newTemplateId } = payload;
      let details = get(state, [oldTemplateId, 'prioritiesToQuantitiesMap']);
      let newTemplateDetails;
      if (state[newTemplateId]) {
        newTemplateDetails = get(state, [
          newTemplateId,
          'prioritiesToQuantitiesMap',
        ]);
        const prioritiesAccumulator = (objValue, srcValue) => {
          return (objValue += srcValue);
        };
        mergeWith(newTemplateDetails, details, prioritiesAccumulator);
      }
      let finalizedDetails = state[newTemplateId]
        ? newTemplateDetails
        : details;
      let newDetails = {
        status: 'inReview',
        prioritiesToQuantitiesMap: finalizedDetails,
        id: newTemplateId,
      };

      let updatedState = omit(state, oldTemplateId);
      updatedState[newTemplateId] = newDetails;
      return updatedState;
    }
    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
